/* Hero slideshow: silver-wipe crossfade, autoplay with pause/play, dots, arrow keys, swipe. */
(() => {
  const init = (hero) => {
    if (hero.dataset.ready) return; hero.dataset.ready = 1;
    const slides = [...hero.querySelectorAll('.hero__slide')];
    if (slides.length < 2) return;
    const dots = [...hero.querySelectorAll('[data-go]')];
    const toggle = hero.querySelector('[data-toggle-play]');
    const wipe = hero.querySelector('.hero__wipe');
    const interval = Number(hero.dataset.interval) || 8000;
    const reduced = window.NS?.tier?.reduced ?? matchMedia('(prefers-reduced-motion: reduce)').matches;
    hero.style.setProperty('--interval', interval + 'ms');
    let index = 0, timer = 0, playing = hero.dataset.autoplay === 'true' && !reduced, hovered = false;

    const go = (i, user) => {
      i = (i + slides.length) % slides.length;
      if (i === index) return;
      if (wipe && !reduced) { wipe.classList.remove('is-running'); void wipe.offsetWidth; wipe.classList.add('is-running'); }
      const swap = () => {
        slides.forEach((s, j) => {
          const on = j === i;
          s.classList.toggle('is-active', on);
          s.toggleAttribute('inert', !on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) s.querySelectorAll('[data-reveal], .silver-sweep, .filigree-draw').forEach((el) => { el.classList.remove('is-in'); requestAnimationFrame(() => el.classList.add('is-in')); });
        });
        dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
        index = i;
      };
      reduced ? swap() : setTimeout(swap, 280);   // exchange while the metallic band crosses
      if (user) restart();
    };
    const tick = () => go(index + 1);
    const restart = () => {
      clearInterval(timer);
      hero.classList.toggle('is-playing', playing && !hovered);
      if (playing && !hovered) timer = setInterval(tick, interval);
    };
    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.go), true)));
    toggle?.addEventListener('click', () => {
      playing = !playing;
      toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
      restart();
    });
    if (!playing) toggle?.setAttribute('aria-label', toggle.dataset.labelPlay);
    hero.addEventListener('keydown', (e) => {
      if (e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
    });
    hero.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hovered = true; restart(); } });
    hero.addEventListener('pointerleave', () => { hovered = false; restart(); });
    hero.addEventListener('focusin', () => { hovered = true; restart(); });
    hero.addEventListener('focusout', (e) => { if (!hero.contains(e.relatedTarget)) { hovered = false; restart(); } });
    let x0 = null;
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) go(index + (dx < 0 ? 1 : -1), true); x0 = null; });
    document.addEventListener('visibilitychange', () => (document.hidden ? clearInterval(timer) : restart()));
    restart();
  };
  const run = () => document.querySelectorAll('[data-hero]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  document.addEventListener('shopify:section:load', run);
})();
